module.exports = __webpack_public_path__ + "static/media/54.7380e58b.jpg";